// Fires a GA4 event. Safe to call even when analytics cookies were
// declined — window.gtag only exists once the visitor accepts the cookie
// banner (see src/utils/cookieConsent.js), so this silently no-ops
// otherwise rather than throwing.
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
};
